import api from '../api';
import {
  CreateProspectListData,
  ProspectList,
  UpdateProspectListData,
} from '../types/prospectList';

export const getProspectLists = async (): Promise<ProspectList[]> => {
  const response = await api.get<ProspectList[]>('/prospect-lists');
  return response.data;
};

export const createProspectList = async (
  data: CreateProspectListData
): Promise<ProspectList> => {
  const response = await api.post<ProspectList>('/prospect-lists', data);
  return response.data;
};

export const updateProspectList = async (
  id: number,
  data: UpdateProspectListData
): Promise<ProspectList> => {
  const response = await api.put<ProspectList>(`/prospect-lists/${id}`, data);
  return response.data;
};

export const deleteProspectList = async (id: number): Promise<void> => {
  await api.delete(`/prospect-lists/${id}`);
};

export interface ProspectListImportPreview {
  headers: string[];
  sampleData: string[][];
  totalRows: number;
}

export const uploadProspectListFile = async (
  listId: number,
  file: File
): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('listId', listId.toString());

  await api.post('/prospect-import/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const previewProspectListImport = async (): Promise<ProspectListImportPreview> => {
  const response = await api.get<ProspectListImportPreview>('/prospect-import/preview');
  return response.data;
};

export const processProspectListImport = async (siretColumn: string): Promise<{
  message: string;
  totalImported: number;
}> => {
  const response = await api.post('/prospect-import/process', { siretColumn });
  return response.data;
};

